/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Property_PublishedInputs */

const cs_enum_property_published = /** @type {(inputs: Enum_Property_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost publikována`)
};

const en_enum_property_published = /** @type {(inputs: Enum_Property_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property published`)
};

/**
* | output |
* | --- |
* | "Property published" |
*
* @param {Enum_Property_PublishedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_property_published = /** @type {((inputs?: Enum_Property_PublishedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Property_PublishedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_property_published(inputs)
	return cs_enum_property_published(inputs)
});